export default {
    namespaced: true,
    state: {
        token: null,
        user: null
    },
    mutations: {
        setToken: function(state, token) {
            state.token = token;
        },
        setUser: function(state, user) {
            state.user = user;
        },
    },
    actions: {
        refreshUser({commit}) {
            return this.$axios.get('/auth/me')
                .then(response => {
                    if(response.data) {
                        commit('setUser', response.data);
                    }

                    return response;
                });
        },

        doAuthUser(context, response) {
            let token = response.data.access_token;
            let user = response.data.user;

            context.commit('setToken', token);
            context.commit('setUser', user);
        },

        doLogoutUser(context) {
            context.commit('setToken', null);
            context.commit('setUser', null);
        },

        registerUser(context, data) {
            return this.$axios.post('/user', data)
                .then(response => {
                    return response;
                });
        },
        updateUser(context, data) {
            return this.$axios.put('/user', data)
                .then(response => {
                    return response;
                });
        },
        deleteAccount() {
            return this.$axios.get('/user/remove').then(response => {
                return response;
            });
        }
    },
    getters: {
        getToken: state => {
            return state.token;
        },

        getUser: state => {
            return state.user;
        }
    }
}
